import React, { useEffect, useState } from 'react';
import api from '../../utils/axiosInstance';
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';
import { useNavigate } from 'react-router-dom';

const SpecialPackageDetails = () => {
    const [specialPackageData, setSpecialPackageData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // fetch the special package alongside regular packages
        const fetchSpecialPackage = async () => {
            try {
                const res = await api.get('/special-package/details');
                if (res.data.success) {
                    setSpecialPackageData(res.data.package);
                    console.log('special');
                }
            } catch (err) {
                console.error('Could not load special package:', err);
            }
        };

        fetchSpecialPackage();
    }, []);

    const handleSubscribe = () => {
        const storedUser = localStorage.getItem('carrierUser');

        if (!storedUser) {
            navigate('/carrier-login');
            return;
        }

        try {
            // Parse stored data
            const parsedUser = JSON.parse(storedUser);
            console.log('parsedUser,', parsedUser.token);

            // Check if token exists
            if (parsedUser.token) {
                // check accountType (extra safety)
                if (parsedUser.accountType !== 'owner' && parsedUser.accountType !== 'manager') {
                    navigate('/carrier-login');
                    return;
                }

                // Logged in -> go to dashboard packages tab
                navigate('/carrier/package');
            } else {
                // Token missing -> treat as not logged in
                navigate('/carrier-login');
            }
        } catch (error) {
            // If JSON parsing fails -> corrupted data
            console.error('Invalid user data:', error);
            navigate('/carrier-login');
        }
    };

    if (!specialPackageData) {
        return <div className='text-center p-10'>Loading package details...</div>;
    }
    return (
        <div className='min-h-screen bg-gray-100 text-gray-900'>
            <HeaderBlue />

            <section className='py-20 px-6 md:px-40 bg-gradient-to-br from-gray-100 to-gray-300'>
                <div className='max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 bg-white rounded-3xl shadow-xl p-10 md:p-12 transform hover:scale-[1.02] transition-transform duration-300'>
                    {/* Left Side */}
                    <div className='md:col-span-2 flex flex-col justify-center'>
                        <h2 className='text-5xl font-extrabold mb-8 text-transparent bg-clip-text  bg-gradient-to-br from-[#d4af37] to-[#92700a] leading-normal'>
                            {specialPackageData.name}
                        </h2>

                        <h3 className='text-2xl md:text-3xl font-semibold mb-4 text-black'>Package Features</h3>

                        <ul className='space-y-3 pl-3'>
                            {specialPackageData.features.map((feat, i) => (
                                <li key={i} className='flex items-center text-gray-800 text-lg'>
                                    <svg
                                        className='w-5 h-5 bluetext1 mr-2'
                                        fill='none'
                                        stroke='currentColor'
                                        viewBox='0 0 24 24'
                                    >
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth='2'
                                            d='M5 13l4 4L19 7'
                                        />
                                    </svg>
                                    {feat}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Right Side */}
                    <div className='bg-gradient-to-br from-[#d4af37] to-[#92700a] text-white rounded-2xl p-8 flex flex-col justify-between'>
                        <div>
                            <p className='text-xl font-semibold mb-2'>Price</p>
                            <p className='text-4xl font-bold mb-6'>
                                {specialPackageData.price === 'custom' ? 'Custom' : `$${specialPackageData.price}`}
                            </p>

                            <p className='text-xl font-semibold mb-2'>Access</p>
                            <p className='mb-4 text-lg'>{specialPackageData.accessDetails} Logins</p>

                            <p className='text-xl font-semibold mb-2'>Duration</p>
                            <p className='mb-4 text-lg'>{specialPackageData.durationDays} Days</p>

                            <p className='text-xl font-semibold mb-2'>Code</p>
                            <p className='mb-6 text-lg'>{specialPackageData.code}</p>
                        </div>

                        <button
                            onClick={handleSubscribe}
                            className='w-full py-3 px-6 bg-white text-black font-semibold rounded-xl hover:bg-gray-200 transition'
                        >
                            Subscribe Now
                        </button>
                    </div>
                </div>
            </section>

            <FooterBlue />
        </div>
    );
};

export default SpecialPackageDetails;
